import React from "react";
import { useOfficeTranslation } from "i18n/OfficeTranslation";

interface Props {
    date: Date;
}

const Date: React.FC<Props> = ({ date }) => {
    const { intlLocale } = useOfficeTranslation();

    const visibleDate = new Intl.DateTimeFormat(intlLocale, {
        day: "numeric",
        month: "short",
    }).format(date);
    const fullDate = new Intl.DateTimeFormat(intlLocale, {
        dateStyle: "medium",
        timeStyle: "medium",
    }).format(date);

    return (
        <span title={fullDate}>{visibleDate}</span>
    );
};

export default Date;
